import { CustomModal } from "../shared/Modal";
import { TextInput } from "../shared/TextInput";
import { FormError } from "../shared/FormError";
import axiosInstance from "../../redux/network/https";
import { endPoints } from "../../redux/network/constant";
import { useSecurityOtpStore } from "../../lib/securityOtpStore";

/**
 * Global OTP step-up modal. Mounted once at the app root — any request that
 * fails with 403 { code: "otp_required" } is held by the axios interceptor
 * and retried automatically once the code is verified here.
 */
const SecurityOtpModal = () => {
  const {
    isOpen,
    challengeId,
    code,
    error,
    isLoading,
    setCode,
    setError,
    setLoading,
    resolvePending,
    rejectPending,
  } = useSecurityOtpStore();

  const handleVerify = async () => {
    if (!/^\d{6}$/.test(code)) {
      setError("Enter the six-digit code from your email.");
      return;
    }
    setLoading(true);
    try {
      await axiosInstance.post(endPoints.SecurityOtpVerify, {
        challenge_id: challengeId,
        code,
      });
      resolvePending();
    } catch (err) {
      setError(err?.response?.data?.message || "Invalid or expired security code.");
    }
  };

  return (
    <CustomModal
      title="Enter security code"
      open={isOpen}
      close={rejectPending}
      primaryButtonText="Verify and continue"
      primaryButtonClick={handleVerify}
      primaryButtonLoading={isLoading}
      secondaryButtonText="Cancel"
      secondaryButtonClick={rejectPending}
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm leading-6 text-grey">
          This action needs extra verification. We sent a six-digit security code to your email. It expires in 10 minutes.
        </p>
        <TextInput
          label="Security code"
          name="code"
          inputMode="numeric"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="123456"
          required
        />
        <FormError message={error} />
      </div>
    </CustomModal>
  );
};

export default SecurityOtpModal;
